import React from "react";
import { withStyles } from "@material-ui/core/styles";

import { Lock } from "@material-ui/icons";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import ConfirmationButton from "./confirmation_button";

import issueStateUpdateRequest from "../components/panel_update_helper";

// img file source: https://drive.google.com/drive/u/0/folders/12EeVkTpbanICnJTUe0QMLxVWnuHW3F3N
var character_images = {
  Character1: "BossJoe_static.png",
  Character2: "Dust_Static.png",
  Character3: "Macie_static.png",
  Character4: "Molly_static.png",
  Character5: "MoonMoon_static.png",
  Character6: "Gachapan.png",
  Character7: "GraffitiSkater_static.png",
  Character8: "Angel.png",
  Character9: "Sorceress.png",
  Character10: "Ryder_static.png",
};

const useStyles = (theme) => ({
  table: {
    minWidth: 650,
  },
  button: {
    margin: 0,
    color: theme.palette.common.white,
    textTransform: "capitalize",
  },
  button_unlock: {
    margin: 0,
    color: theme.palette.common.blue,
    textTransform: "capitalize",
  },
  character_avatar: {
    marginRight: 15,
    border: "1px solid rgba(0, 0, 0, 0.6)",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.5)",
  },
});

class CharactersTableLinkButton extends React.Component {
  handleCharacterButtonClick = async (
    playerId,
    characterId,
    onCharacterTableChange
  ) => {
    await issueStateUpdateRequest(
      this,
      "/player_info_panel/unlock_character",
      {
        playerId: playerId,
        characterId: characterId,
      },
      "post"
    );

    onCharacterTableChange();
    return false;
  };

  render() {
    const characterId = this.props.characterIds[this.props.rowIndex];

    if (this.props.unlockStates[this.props.rowIndex]) {
      return (
        <a href={this.props.tableUrls[this.props.rowIndex]}>
          <Button
            variant="contained"
            color={"primary"}
            className={this.props.classes.button}
          >
            <Avatar
              src={
                "/assets/img/characters/static/" + character_images[characterId]
              }
              className={this.props.classes.character_avatar}
            />
            {this.props.cell}
          </Button>
        </a>
      );
    }

    return (
      <ConfirmationButton
        onClick={() =>
          this.handleCharacterButtonClick(
            this.props.playerId,
            characterId,
            this.props.onCharacterTableChange
          )
        }
        title="Unlock Character"
        className={this.props.classes.button_unlock}
        color={"default"}
        startIcon={<Lock />}
        confirmationMessage={"Confirming will unlock character " + characterId}
      >
        <Avatar
          src={"/assets/img/characters/static/" + character_images[characterId]}
          className={this.props.classes.character_avatar}
        />
        {this.props.cell}
      </ConfirmationButton>
    );
  }
}

class CharacterTable extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <TableContainer key={this.props.tableKey} component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {this.props.tableHeaders.map((header) => (
                <TableCell key={"header-" + header}>
                  <b>{header}</b>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.tableRows.map((row, rowIndex) => (
              <TableRow key={this.props.tableKey + "-row-" + rowIndex}>
                {row.map((cell, cellIndex) =>
                  this.props.tableRows &&
                  cellIndex === 0 &&
                  this.props.tableUrls[rowIndex] != null ? (
                    <TableCell key={this.props.tableKey + "-cell-" + cellIndex}>
                      {
                        <CharactersTableLinkButton
                          cell={cell}
                          playerId={this.props.playerId}
                          classes={this.props.classes}
                          rowIndex={rowIndex}
                          tableUrls={this.props.tableUrls}
                          tableRows={this.props.tableRows}
                          unlockStates={this.props.unlockStates}
                          characterIds={this.props.characterIds}
                          onCharacterTableChange={
                            this.props.onCharacterTableChange
                          }
                        />
                      }
                    </TableCell>
                  ) : (
                    <TableCell key={this.props.tableKey + "-cell-" + cellIndex}>
                      {cell}
                    </TableCell>
                  )
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

export default withStyles(useStyles)(CharacterTable);
